<template>
  <div id="Footer">
    <div class="end">
      Copyright&copy; &nbsp;2019-{{ DataYears }} &nbsp;印工社（青岛）数字科技有限公司 All
      Rights Reserved&nbsp; | &nbsp;鲁ICP备12040237号-2&nbsp; 鲁公网安备 44030502001025号
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterPart',
  computed: {
    DataYears() {
      const date = new Date();
      const years = date.getFullYear();

      return years;
    },
  },
};
</script>

<style lang="scss" scoped>
.end {
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
}
</style>
